import { render, staticRenderFns } from "./BSJ_video_loss-modal.vue?vue&type=template&id=77881906&scoped=true"
import script from "./BSJ_video_loss-modal.vue?vue&type=script&lang=js"
export * from "./BSJ_video_loss-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77881906",
  null
  
)

export default component.exports